module.exports = __webpack_public_path__ + "media/images/icon_nav_amount_white-4774b6769498a4f6f3040a6ab7d06cec.svg";